import { gqlMutationFactory, gqlQueryFactory } from '@/graphql/operations';
import { jotaiStore } from '@/stores/jotaiStore';
import { BusinessContext, JotaiAttributeStore } from '@skand/business';

const attributeStore = new JotaiAttributeStore({ jotaiStore });
export const businessContext = new BusinessContext({
  attributeStore,
  gqlMutationFactory,
  gqlQueryFactory,
});
